import Alipay from "chameleon/icons/alipay";
import Ideal from "chameleon/icons/ideal";
import Paypal from "chameleon/icons/paypal";
import Trustly from "chameleon/icons/trustly";
import WechatPay from "chameleon/icons/wechat-pay";

import { PaymentType } from "checkout-query-client/types/form-types";

const LpmIcon = ({ paymentType }: { paymentType: PaymentType | undefined }) => {
  switch (paymentType) {
    case PaymentType.ideal:
      return (
        <Ideal
          sizeVariant={24}
          isRectangle
          aria-hidden="true"
          role={"presentation"}
        />
      );
    case PaymentType.alipay:
      return (
        <Alipay
          sizeVariant={24}
          isRectangle
          aria-hidden="true"
          role={"presentation"}
        />
      );
    case PaymentType.trustly:
      return (
        <Trustly
          sizeVariant={24}
          isRectangle
          aria-hidden="true"
          role={"presentation"}
        />
      );
    case PaymentType.wechatPay:
      return (
        <WechatPay
          sizeVariant={24}
          isRectangle
          aria-hidden="true"
          role={"presentation"}
        />
      );
    case PaymentType.paypal:
      return (
        <Paypal
          sizeVariant={24}
          isRectangle
          aria-hidden="true"
          role={"presentation"}
        />
      );
    default:
      return null;
  }
};

export default LpmIcon;
